<template>
  <v-app :class="{ 'fullView': !mobile }">
    <v-app-bar app dense color="white" class="appBar" clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-show="mobile"></v-app-bar-nav-icon>
      <div class="titleContainer d-flex justify-center">
        <v-toolbar-title class="mr-12">
          <span class="title" black--text>Hillsbrook</span>
        </v-toolbar-title>

        <!-- <v-img
          src="https://placeimg.com/640/200/any"
          height="100px"
          max-width="400px"
          v-show="!mobile"
        ></v-img>-->
      </div>
      <!-- <v-spacer></v-spacer> -->
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense class="navList d-flex flex-column fill-height">
        <v-list-item v-for="item in items" :key="item.text" link :to="item.to">
          <v-list-item-action>
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-subheader class="mt-4 grey--text text--darken-1">SUBSCRIPTIONS</v-subheader>
        <v-list>
          <v-list-item v-for="item in items2" :key="item.text" link>
            <v-list-item-avatar>
              <img :src="`https://randomuser.me/api/portraits/men/${item.picture}.jpg`" alt />
            </v-list-item-avatar>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item>
        </v-list>-->

        <v-spacer></v-spacer>

        <v-list-item-group class="bottomNavItems d-flex flex-row justify-space-around">
          <v-list-item link>
            <v-list-item-action>
              <v-icon color="grey darken-1">mdi-account</v-icon>
            </v-list-item-action>
            <!-- <v-list-item-title class="grey--text text--darken-1">Account</v-list-item-title> -->
          </v-list-item>
          <v-list-item link>
            <v-list-item-action>
              <v-icon color="grey darken-1">mdi-plus-circle-outline</v-icon>
            </v-list-item-action>
            <!-- <v-list-item-title class="grey--text text--darken-1">Browse Channels</v-list-item-title> -->
          </v-list-item>
          <v-list-item link>
            <v-list-item-action>
              <v-icon color="grey darken-1">mdi-cog</v-icon>
            </v-list-item-action>
            <!-- <v-list-item-title class="grey--text text--darken-1">Manage Subscriptions</v-list-item-title> -->
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main class="main">
      <v-container class="fill-height">
        <v-row class="fill-height">
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    items: [
      { title: 'Hjem', icon: 'home', to: '/' },
      { title: 'Om Hillsbrook', icon: 'information', to: '/om' },
      { title: 'Nyheder', icon: 'newspaper-variant', to: '/nyheder' },
      { title: 'Hunde', icon: 'file', to: '/hunde' },
      // undersider her
      { title: 'Hvalpe', icon: 'file', to: '/hvalpe' },
      // undersider her
      { title: 'Resultater', icon: 'file', to: '/resultater' },
      // undersider her
      { title: 'Salg', icon: 'cart', to: '/salg' },
      { title: 'Kontakt', icon: 'phone', to: '/kontakt' },
      { title: 'Links', icon: 'link-variant', to: '/links' }

      // undersider: https://vuetifyjs.com/en/components/lists/#nested-lists
    ]
    // items2: [
    //   { picture: 28, text: 'Joseph' },
    //   { picture: 38, text: 'Apple' },
    //   { picture: 48, text: 'Xbox Ahoy' }
    // ]
  }),
  computed: {
    mobile: function () {
      // Just to shorten the variable when using it in the template
      return this.$vuetify.breakpoint.mobile;
    }
  },
  created() {
    this.$vuetify.theme.dark = false;
  }
};
</script>

<style lang="less">
// Import styling for lightbox
@import '../node_modules/vue-image-lightbox/dist/vue-image-lightbox.min.css';
// require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

.fullView {
  // fullView styles here
}

// Color for active nav item
.v-list-item--active {
  i.v-icon {
    color: var(--v-primary-base) !important;
  }
}

.titleContainer {
  width: 100%;
}

.navList {
  a {
    flex: 0 0 auto !important; // to prevent they flex and get higher
  }

  .bottomNavItems {
    .v-list-item {
      flex: 0 0 auto !important;

      .v-list-item__action {
        margin: 0 !important;
      }
    }
  }
}
</style>